
import { DatePickerComponent } from '@syncfusion/ej2-react-calendars';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import Moment from 'moment';
import React from 'react';
import { Loading } from 'react-loading-ui';
import { connect } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import * as constants from './Constants';
import environment from './environments/environment';
import CancelModalComponent from './popUpModals/CancelModalComponent';
import SubmitModalComponent from './popUpModals/SubmitModalComponent';

class NewCase extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            show: false,
            shows: false,
            caseId: '',
            caseName: '',
            attorney: '',
            supervisor: '',
            reportStartDate: new Date(),
            reportInterval: '',
            isActive: '',
            reDirect: '',
            supervisors: [],
            attorneys: [],
            caseList: [],
            errorCaseNameMessage: '',
            errorAttoryneyNameMessage: '',
            errorSupervisorNameMessage: '',
            errorReportIntervalMessage: '',
            errorReportStartDateMessage: '',
            errorCaseNameMessage1: '',

        }
    }

    componentDidMount = async () => {
        if (this.props.userStatus.userName !== "") {
            this.setState({
                caseId: this.state.caseId,
                email: this.props.userStatus.emailId,
                //supervisor: this.props.userStatus.userId,

            }, () => {

            })

            if (this.props.location.state !== undefined && this.props.location.state.caseId !== undefined) {
                this.toCaseList();
            } else {
                this.state.supervisor = this.props.userStatus.userId;
                this.getSupervisor(this.state.supervisor);
            }
        } else {
            this.setState({

                reDirect: '/',

            })
        }

    }
    getSupervisor(value) {
        axios.get(environment.getAllSupervisors)
            .then(response => {
                if (response.data !== null) {
                    this.setState({
                        supervisors: response.data,
                    });
                    if (value > 0) {
                        this.getAttorney(value);
                    }
                }
            })
    }
    getAttorney(value) {
        axios.get(environment.getAllAttorneys + value)
            .then(response => {
                if (response.data !== null) {
                    this.setState({
                        attorneys: response.data,
                        // attorney: ''
                    });
                }
            })
    }

    toCaseList() {
        if (this.props.location.state.caseId !== undefined) {
            axios.get(environment.getCaseInfoByID + this.props.location.state.caseId)
                .then(response => {
                    if (response.data.apiResponseVO.type === constants.API_RESPONSE_TYPE_SUCCESS && response.data !== null && response.data !== undefined) {
                        this.setState({ caseList: response.data.caseVOList[0] }
                            , () => {
                                this.setState({
                                    caseId: this.state.caseList.caseId,
                                    caseName: this.state.caseList.caseName,
                                    attorney: this.state.caseList.attorneyId,
                                    supervisor: this.state.caseList.supervisorId,
                                    reportStartDate: this.state.caseList.reportStartDate,
                                    reportInterval: this.state.caseList.reportInterval,
                                    createdBy: this.state.caseList.createdBy,
                                    createdTime: this.state.caseList.createdTime,
                                    lastReportSent: this.state.caseList.lastReportSent
                                });
                                this.getSupervisor(this.state.caseList.supervisorId);
                            }

                        );
                    }


                });
        }

    }
    checkCaseName(value) {
        axios.get(environment.checkCaseName + '?caseName=' + value)
            .then(response => {
                if (response.data === true) {
                    this.setState({
                        errorCaseNameMessage1: "Case with this name already exists",
                    })
                } else {
                    this.setState({
                        errorCaseNameMessage1: ""
                    })
                }
            }
            );
    }

    changeValue = (e) => {
        this.setState({ [e.target.name]: e.target.value })
        if (e.target.name === 'caseName') {
            this.toValiadetCaseName();
            this.checkCaseName(e.target.value);

        }
        if (e.target.name === 'attorney') {
            this.toValiadetAttorney();
        }
        if (e.target.name === 'supervisor') {
            this.toValiadetSupervisor();
            this.getAttorney(e.target.value);
            this.state.attorney = '';
        }
        if (e.target.name === 'reportStartDate') {
            this.toValiadetReportStartDate();
        }
        if (e.target.name === 'reportInterval') {
            // this.setState({ [e.target.name]: e.target.value.replace(/\D/g, '') })
            this.toValiadetReportInterval();
        }
    }
    async toValiadetCaseName() {
        this.setState({
            errorCaseNameMessage: "",
        }, () => {
            if (this.state.caseName.trim() === "") {
                this.setState({
                    errorCaseNameMessage: "Case Name required",
                })
            }
        })
    }
    async toValiadetAttorney() {
        this.setState({
            errorAttoryneyNameMessage: "",
        }, () => {
            if (this.state.attorney === "") {
                this.setState({
                    errorAttoryneyNameMessage: " Please select Attorney ",
                })
            }
        })
    }
    async toValiadetSupervisor() {
        this.setState({
            errorSupervisorNameMessage: "",
        }, () => {
            if (this.state.supervisor === "") {
                this.setState({
                    errorSupervisorNameMessage: " Please select Supervisor ",
                })
            }
        })
    }
    async toValiadetReportStartDate() {
        this.setState({
            errorReportStartDateMessage: "",
        }, () => {
            if (this.state.reportStartDate === null) {
                this.setState({
                    errorReportStartDateMessage: "Report Start date required",
                })
            }
        })
    }
    async toValiadetReportInterval() {
        this.setState({
            errorReportIntervalMessage: "",
        }, () => {
            if (this.state.reportInterval === "") {
                this.setState({
                    errorReportIntervalMessage: "Please select Report interval",
                })
            }
        })
    }
    async onSubmit(event) {
        event.preventDefault();
        await this.toValiadetCaseName();
        await this.toValiadetAttorney();
        await this.toValiadetSupervisor();
        await this.toValiadetReportInterval();
        await this.toValiadetReportStartDate();
        if (this.state.errorCaseNameMessage === "" && this.state.errorAttoryneyNameMessage === "" && this.state.errorCaseNameMessage1 === "" &&
            this.state.errorSupervisorNameMessage === "" && this.state.errorReportIntervalMessage === "" && this.state.errorReportStartDateMessage === "") {
            this.setState({ shows: true });
        }
    }

    onCloseModal() {
        this.setState({ show: false });
    };
    showModal = () => {
        this.setState({ show: true });
    };
    onCancelChanges() {
        this.setState({
            reDirect: "/caseSummary"
        })
    };
    onSubmitModal() {
        this.setState({ shows: false });
    };
    showSubmitModal = () => {
        this.setState({ shows: true });
    };

    onSubmitChanges() {
        this.onSubmitModal();
        this.toSave();
    }
    toSave() {
        Loading();
        let caseVO = {};
        var d = new Date(); // get current date
        caseVO.caseReportHistory = null;
        caseVO.caseId = this.state.caseId;
        caseVO.caseName = this.state.caseName;
        caseVO.attorneyId = this.state.attorney;
        caseVO.supervisorId = this.state.supervisor;
        caseVO.reportStartDate = this.state.reportStartDate;
        caseVO.reportInterval = this.state.reportInterval;
        caseVO.lastReportSent = this.state.lastReportSent;
        caseVO.isActive = constants.IS_ACTIVE_YES;
        if (this.state.caseId !== undefined && this.state.caseId !== null && this.state.caseId !== '') {
            caseVO.createdBy = this.state.createdBy;
            caseVO.createdTime = this.state.createdTime;
        } else {
            caseVO.createdBy = this.state.email;
            caseVO.createdTime = '';
        }

        caseVO.lastUpdatedBy = this.state.email;

        caseVO.lastUpdatedTime = '';
        axios.post(environment.postCaseInfoDetails, caseVO)
            .then(response => {

                if (response.data.apiResponseVO.type === constants.API_RESPONSE_TYPE_SUCCESS) {
                    this.setState({ reDirect: '/caseSummary' })
                    setTimeout(() => {
                        Loading();
                    });
                    toast.success(response.data.apiResponseVO.message,
                        { position: toast.POSITION.TOP_CENTER }
                    )

                } else {
                    toast.error(response.data.apiResponseVO.message, { position: toast.POSITION.TOP_CENTER })
                    this.setState({ reDirect: '/caseSummary' })
                    setTimeout(() => {
                        Loading();
                    });
                }


            })
            .catch((error) => {
                toast.error(error.message, { position: toast.POSITION.TOP_CENTER })
                this.setState({ reDirect: '/caseSummary' })
                setTimeout(() => {
                    Loading();
                });
            });
    }

    render() {
        if (this.state.reDirect) {
            return <Redirect to={{
                pathname: this.state.reDirect, state: {
                    caseId: this.state.caseId,


                }

            }} />
        }
        return (
            <React.Fragment>
                <form onSubmit={(event) => this.onSubmit(event)}>
                    <div className="container pl-0  pr-0 ">
                        <div className="row mt-1 mb-0">
                            <div className="col-md-6">
                                {(this.state.caseId !== undefined && this.state.caseId !== null && this.state.caseId !== '') ? (<h4>Edit  Case</h4>) : (<h4>New Case </h4>)}

                            </div>
                        </div>
                        <hr></hr>
                        <div className="row">
                            <div className="col-6">
                                <div className="form-group " >
                                    <div className="row">
                                        <label style={{ width: '30%', marginLeft: '5%', textAlign: 'right' }}> <b>Case Name</b><span className="required"></span>
                                            <b className="float-right " style={{ width: '5%' }}>:</b>
                                        </label>
                                        <div style={{ width: '35%' }}>
                                            <input type="text" id="caseName" name="caseName" placeholder="Case Name" maxLength={250} value={this.state.caseName} onChange={this.changeValue}
                                            />
                                            <p className="text-danger" style={{ width: '250px' }}>{this.state.errorCaseNameMessage}</p>
                                            <p className="text-danger" style={{ width: '250px' }}>{this.state.errorCaseNameMessage1}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="form-group mt-1 "  >
                                    <div className="row">
                                        <label className="col-8 " style={{ width: '30%', marginLeft: '5%', textAlign: 'right' }}> <b>Supervisor</b><span className="required"></span>
                                            <b className="float-left " style={{ width: '5%' }}>:</b>
                                        </label>
                                        <div style={{ width: '35%' }}>
                                            <select className=" col-12" name="supervisor" value={this.state.supervisor} onChange={this.changeValue}  >
                                                <option value="">Select</option>
                                                {this.state.supervisors.map((supervisor) => (
                                                    <option key={supervisor.supervisorId} value={supervisor.supervisorId}
                                                    >{supervisor.supervisor}</option>
                                                ))}
                                            </select>
                                            <p className="text-danger" style={{ width: '250px' }}>{this.state.errorSupervisorNameMessage} </p> </div>
                                    </div>
                                </div>
                                <div className="form-group  mt-1 " >
                                    <div className="row">
                                        <label style={{ width: '30%', marginLeft: '5%', textAlign: 'right' }}> <b>Attorney </b><span className="required"></span>
                                            <b className="float-right " style={{ width: '5%' }}>:</b>
                                        </label>                                <div style={{ width: '35%' }}>
                                            <select className=" col-12" name="attorney" value={this.state.attorney} onChange={this.changeValue}  >
                                                <option value="">Select</option>
                                                {this.state.attorneys.map((attorney) => (
                                                    <option key={attorney.attorneyId} value={attorney.attorneyId}
                                                    >{attorney.attorneyName}</option>
                                                ))}
                                            </select>
                                            <p className="text-danger" style={{ width: '250px' }}> {this.state.errorAttoryneyNameMessage}</p>  </div>
                                    </div>
                                </div>

                                <div className="form-group mt-1 "  >
                                    <div className="row">
                                        <label className="col-8 " style={{ width: '30%', marginLeft: '5%', textAlign: 'right' }}> <b>Report Start</b><span className="required"></span>
                                            <b className="float-left " style={{ width: '5%' }}>:</b>
                                        </label>
                                        <div style={{ width: '35%' }}>

                                            <DatePickerComponent id="reportStartDate" name="reportStartDate" allowEdit={false} showTodayButton={false} enabled={this.state.lastReportSent == null}
                                                value={Moment(this.state.reportStartDate).format('MM/DD/YYYY ')} onChange={this.changeValue} ></DatePickerComponent>
                                            <p className="text-danger" style={{ width: '250px' }}>{this.state.errorReportStartDateMessage} </p>
                                        </div>

                                    </div>
                                </div>

                                <div className="form-group mt-1 "  >
                                    <div className="row">
                                        <label className="col-8 " style={{ width: '30%', marginLeft: '5%', textAlign: 'right' }}> <b>Report Interval</b><span className="required"></span>
                                            <b className="float-left " style={{ width: '5%' }}>:</b>
                                        </label>
                                        <div style={{ width: '35%' }}>
                                            <select className=" col-12" name="reportInterval" value={this.state.reportInterval} onChange={this.changeValue}  >
                                                <option selected value="">Select</option>
                                                <option value="15">15</option>
                                                <option value="30">30</option>
                                                <option value="45">45</option>
                                                <option value="60">60</option>
                                                <option value="90">90</option>
                                                <option value="180">180</option>
                                                <option value="270">270</option>

                                            </select>
                                            <p className="text-danger" style={{ width: '250px' }}>{this.state.errorReportIntervalMessage}  </p> </div>
                                    </div>
                                </div>

                            </div>
                            {/* <div className="col-6">
                        <div className="form-group mt-1 "  >
                            <div className="row">
                                <label className="col " style={{ width: '30%', marginLeft: '5%', textAlign: 'right' }}> <b>Bulk Case(s) Upload</b>
                                    <b className="float-left " style={{ width: '5%' }}>:</b>
                                </label>
                                <div className="col-7" >
                                    <form method="post" enctype="multipart/form-data">
                                        <div className=" form-group files color ml-5" style={{ width: '100%' }}>
                                            <input type="file" onChange={this.onFileChange} />
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>

                    </div> */}
                        </div>
                        <hr></hr>
                        <main>
                            <div className="row mb-2" >
                                <div>

                                    <Link to="/caseSummary"><span
                                        className="btn btn-primary  " style={{ marginRight: '1%', backgroundColor: '#ADD8E6', color: '#000', borderColor: '#000' }} >Back</span></Link>
                                    <button type="submit"
                                        className="btn btn-primary  " style={{ marginRight: '1%', backgroundColor: '#ADD8E6', color: '#000', borderColor: '#000' }} >Submit  </button>

                                    <button type="button" onClick={this.showModal}
                                        className="btn btn-primary  " style={{ marginRight: '1%', backgroundColor: '#ADD8E6', color: '#000', borderColor: '#000' }} >Cancel </button>

                                </div>
                            </div>
                            <CancelModalComponent show={this.state.show} hideModal={() => this.onCloseModal()} cancelChanges={() => this.onCancelChanges()}></CancelModalComponent>
                            <SubmitModalComponent show={this.state.shows} hideModal={() => this.onSubmitModal()} submitChanges={() => this.onSubmitChanges()}></SubmitModalComponent>
                        </main>
                        <ToastContainer style={{ marginTop: '7%' }} />
                    </div>


                </form>
            </React.Fragment>

        )
    }
}
const mapStateToProps = (state) => {

    return {

        userStatus: state.lognReducer
    }
};

export default connect(mapStateToProps)(NewCase);
